var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { Field } from "react-final-form";
import { FormattedMessage } from "react-intl";
import { useHelpTooltip } from "../../hooks/useHelpTooltip";
import { HelpTooltip } from "./HelpTooltip";
import styles from "./RecekField.module.css";
export var RecekField = function (_a) {
    var id = _a.id, labelId = _a.labelId, name = _a.name, children = _a.children, props = __rest(_a, ["id", "labelId", "name", "children"]);
    var _b = useHelpTooltip(labelId), helpId = _b.helpId, hasHelp = _b.hasHelp;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { center: "xs" },
            React.createElement(Col, { xs: 6 },
                React.createElement("div", { className: styles.fieldWrapper },
                    React.createElement("label", { htmlFor: id, className: styles.label },
                        React.createElement(FormattedMessage, { id: labelId })),
                    hasHelp && React.createElement(HelpTooltip, { id: "".concat(labelId, "-help"), textId: helpId })))),
        React.createElement(Row, { center: "xs" },
            React.createElement(Col, { xs: 6 },
                React.createElement(Field, __assign({ id: id, name: name }, props)),
                children && React.createElement("div", { className: styles.centerChildren }, children)))));
};
